module.exports = __webpack_public_path__ + "static/media/icon.01b7fbf3.png";